import { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { useWallet } from '../lib/wallet';
import type { Settlement } from '../../../../packages/sdk/src/index';

/** The authenticated API derives eligibility from gateway ownership and state. */
export function RedemptionControl({ settlement, onUpdate }: { settlement: Settlement; onUpdate: () => Promise<void> }) {
  const wallet = useWallet();
  const [pendingCancel, setPendingCancel] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { setPendingCancel(false); setError(''); }, [settlement.id]);
  const cancel = async () => {
    if (!settlement.canRequestCancellation || !settlement.requestId || pendingCancel) return;
    setError('');
    try {
      // The prepared transaction and gateway recheck ownership and REQUESTED.
      // If source preparation wins the race, cancellation cannot bypass its guard.
      await wallet.execute({ action: 'cancelRedemption', requestId: settlement.requestId });
      setPendingCancel(true);
      await onUpdate();
    } catch (e) { setError(e instanceof Error ? e.message : 'Cancellation was not submitted.'); }
  };
  const acknowledged = settlement.state === 'cancelled';
  const cancelling = !acknowledged && (pendingCancel || settlement.state === 'cancellation_pending');
  return <div>
    {settlement.canRequestCancellation && settlement.requestId && !cancelling && !acknowledged && <><Button variant="outline" className="full-width" style={{ marginTop: 18 }} disabled={wallet.busy || wallet.chainId !== wallet.config?.chainId} onClick={cancel}>Request cancellation</Button><p className="micro muted" style={{ marginTop: 9 }}>Available only before receipt burn. Receipts remain escrowed until the source cancellation acknowledgement returns.</p></>}
    {cancelling && <p className="notice" role="status">Cancellation is pending acknowledgement. The escrowed receipts have not yet been returned.</p>}
    {acknowledged && <p className="notice notice-success" role="status">Cancellation acknowledged. The gateway returned the escrowed receipts to your wallet.</p>}
    {error && <p className="notice notice-error" role="alert">{error}</p>}
  </div>;
}
